// 对比验证结果：两列（旧版 / 当前版）逐步对比步骤名、页面签名、截图；运行中每 5 秒刷新
import { Link, useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { useMediaToken } from "../../lib/media";
import { useInterval, useLoad } from "../../lib/hooks";
import { mediaUrl } from "../../lib/net";
import { useLightbox } from "../../components/Lightbox";
import { StatusBadge } from "../../components/Badges";
import { PageHeading } from "../../components/PageHeading";

export function ComparePage() {
  const { group = "" } = useParams();
  const q = useLoad(() => api.compareResult(group), [group]);
  const lb = useLightbox();
  const token = useMediaToken();
  const cols = q.data ?? [];
  const running = cols.some((c) => !["done", "failed", "cancelled", "archived"].includes(c.status));
  useInterval(() => void q.reload(), running ? 5000 : null);
  const ks = [...new Set(cols.flatMap((c) => c.steps.map((s) => s.k)))].sort((a, b) => a - b);
  const a = cols[0];
  const b = cols[1];

  return (
    <div>
      <PageHeading
        title="对比验证"
        desc={
          <>
            同一份测试资料分别用旧版和当前版 SOP 各 dry run 一次，逐步对比；页面签名不同的格子红框标出
            {running && " · 运行中，每 5 秒自动刷新"} · <span className="mono">{group}</span>
          </>
        }
      >
        <button className="btn" onClick={() => history.back()}>
          ← 返回
        </button>
      </PageHeading>
      {q.error && <div className="notice err">{q.error}</div>}
      {cols.length > 0 && (
        <div className="compare-grid" style={{ marginBottom: 12 }}>
          <b>步骤</b>
          {cols.slice(0, 2).map((c) => (
            <div key={c.taskId} className="cell">
              <b>{c.label}</b>{" "}
              <StatusBadge status={c.status} />
              <div className="small">
                <Link to={`/tasks/${c.taskId}`}>打开任务</Link>
                {c.minutes !== null && <> · {c.minutes} 分钟</>}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="compare-grid">
        {ks.map((k) => {
          const sa = a?.steps.find((s) => s.k === k);
          const sb = b?.steps.find((s) => s.k === k);
          const diff = !!(sa && sb && sa.sig && sb.sig && sa.sig !== sb.sig) || (!!sa !== !!sb);
          return [
            <b key={`k${k}`}>{k}</b>,
            ...[sa, sb].map((s, i) => (
              <div key={`${k}-${i}`} className={`cell${diff ? " diff-sig" : ""}`}>
                {s ? (
                  <>
                    <div>{s.label}</div>
                    <div className="small muted mono">签名 {s.sig ?? "—"}</div>
                    {s.screenshot && token && (
                      <img src={mediaUrl(s.screenshot, token)} alt={`第 ${k} 步`} onClick={() => lb.open(mediaUrl(s.screenshot, token))} />
                    )}
                  </>
                ) : (
                  <span className="muted">（没有这一步）</span>
                )}
              </div>
            )),
          ];
        })}
      </div>
      {cols.length > 0 && ks.length === 0 && <div className="empty">{running ? "两次 dry run 正在执行，稍候自动刷新…" : "没有步骤记录"}</div>}
      {lb.node}
    </div>
  );
}
